import styled from 'styled-components';

import { Header as HeaderBase } from 'components/Payment/PaymentCardItem/styles';
import ShimmerBase from 'components/Shimmer/styles';

export const Header: any = styled(HeaderBase)`
  height: 82px;
`;

Header.Icon = styled.div`
  height: 48px;
  width: 48px;
  margin-right: 14px;
  border-radius: 24px;

  & ${ShimmerBase} {
    border-radius: 24px;
  }
`;
